import ReportFilters from './ReportFilters.js';

( function ( $ ){
	$( document ).ready( function (){
		// Init filters
		ReportFilters.init();
		// Init report
		CourseReport.init();
	} );

	var CourseReport = {
		$elements: {},
		strings: {},
		groupLeaderData: false,

		init: function (){

			// Check if we're dealing with a group leader.
			if (typeof UO_CEU_EDITOR.group_leader_data !== 'undefined' && UO_CEU_EDITOR.group_leader_data) {
				this.groupLeaderData = UO_CEU_EDITOR.group_leader_data;
			}

			// Get main element
			this.$elements.container = $( '.ucec-report' );
			this.$elements.table     = $( '#ucec-course-report' );

			// Check if the element exists
			if (this.$elements.table.length > 0) {
				// Get translatable strings
				this.strings.csvFileName = this.$elements.table.data( 'csvfilename' );

				// Create DataTable
				this.dataTables();
			}
		},

		get_options: function ( element, return_selected_value = false ){
			let options = [];

			let selected = 0;


			Array.from( document.querySelector( element ).options ).forEach( function ( option_element ){

				let option_text;

				if ('0' === option_element.value && '#ucec-courses' === element) {
					option_text = UO_CEU_EDITOR.l10n.report.form.custom;
				} else if ('0' === option_element.value) {
					return;
				} else {
					option_text = option_element.text;
				}

				let option_value       = option_element.value;
				let is_option_selected = option_element.selected;

				if( typeof UO_CEU_EDITOR.ceu_courses[option_value] !== "undefined" ){
					options.push( {label: option_text, value: option_value} );
				}

				if (is_option_selected === true) {
					selected = option_value
				}
			} );

			if (return_selected_value) {
				return selected;
			}

			return options;
		},

		dataTables: function (){
			// Object reference
			let _this = this;

			const editor = new $.fn.dataTable.Editor( {
				ajax: {
					create: {
						type: 'POST',
						url: UO_CEU_EDITOR.api.root + '/modify_table',
						// Attach Nonce to the header of the request
						beforeSend: function ( xhr ){
							xhr.setRequestHeader( 'X-WP-Nonce', UO_CEU_EDITOR.api.nonce );
						},
					},
					edit: {
						type: 'POST',
						url: UO_CEU_EDITOR.api.root + '/modify_table',
						// Attach Nonce the the header of the request
						beforeSend: function ( xhr ){
							xhr.setRequestHeader( 'X-WP-Nonce', UO_CEU_EDITOR.api.nonce );
						},
						data: function ( d ){
							if ('edit' === d.action) {
								d.ceu_row_id = $('.ucec-report-results-table__tr.selected').attr('id');
								
								var row_data = _this.$elements.dataTable.row('.selected').data();
								
								d.row_user = row_data['user'];
								d.row_course = row_data['course'];
								d.row_course_id = row_data['course_id'];
								
								return d;
							}
						}
					},
					remove: {
						type: 'POST',
						url: UO_CEU_EDITOR.api.root + '/modify_table',
						// Attach Nonce to the header of the request
						beforeSend: function ( xhr ){
							xhr.setRequestHeader( 'X-WP-Nonce', UO_CEU_EDITOR.api.nonce );
						},
						data: function ( d ){

							if ('remove' === d.action) {
								/*
								DT ajax passes row -> column inner text as data. our cells have HTML with a data attr.
								Lets parse out the data from innerHTML of the cell.
								*/

								let ceuData = {
									action: 'remove',
									data: [],
								};

								for (let key in d.data) {
									// skip loop if the property is from prototype
									ceuData.data.push(
										{
											user: d.data[key].user_id,
											course: d.data[key].course_id,
											date: d.data[key].ceu_date,
											report_mode: UO_CEU_EDITOR.report_mode
										}
									);

								}

								d = ceuData;
								return d;
							}
						}
					},
				},
				table: _this.$elements.table,
				i18n: {
					create: {
						button: UO_CEU_EDITOR.l10n.report.create.button,
						title: UO_CEU_EDITOR.l10n.report.create.title,
						submit: UO_CEU_EDITOR.l10n.report.create.submit
					},
					edit: {
						button: UO_CEU_EDITOR.l10n.report.edit.button,
						title: UO_CEU_EDITOR.l10n.report.edit.title,
						submit: UO_CEU_EDITOR.l10n.report.edit.submit
					},
					remove: {
						button: UO_CEU_EDITOR.l10n.report.remove.button,
						title: UO_CEU_EDITOR.l10n.report.remove.title,
						submit: UO_CEU_EDITOR.l10n.report.remove.submit,
						confirm: {
							_: UO_CEU_EDITOR.l10n.report.remove.confirm_,
							1: UO_CEU_EDITOR.l10n.report.remove.confirm1
						}
					},
				},
				idSrc: 'DT_RowId',
				fields: [
					{
						label: UO_CEU_EDITOR.l10n.report.form.user,
						name: "user_dropdown",
						type: "select",
						options: [],
						placeholderDisabled: true,
						className: 'ucec-report-modal-field ucec-report-modal-field--users',
					},
					{
						label: UO_CEU_EDITOR.l10n.report.form.user,
						name: "user",
						className: 'ucec-report-modal-field ucec-report-modal-field--hidden'
					},
					{
						label: UO_CEU_EDITOR.l10n.report.form.course,
						name: "course",
						type: "select",
						options: _this.get_options( '#ucec-courses' ),
						def: _this.get_options( '#ucec-courses', true ),
						placeholderDisabled: true,
						className: 'ucec-report-modal-field ucec-report-modal-field--courses'
					},
					{
						label: UO_CEU_EDITOR.l10n.report.form.customTitle,
						name: "customCourse",
						className: 'ucec-report-modal-field ucec-report-modal-field--title'
					},
					{
						label: UO_CEU_EDITOR.l10n.report.form.completeCourse,
						name: "completeCourse",
						type: "radio",
						options: [
							{label: UO_CEU_EDITOR.l10n.report.form.yes, value: 1},
							{label: UO_CEU_EDITOR.l10n.report.form.no, value: 0}
						],
						def: 0,
						className: 'ucec-report-modal-field ucec-report-modal-field--complete-course'
					},
					{
						label: UO_CEU_EDITOR.l10n.report.form.ceus,
						name: "ceus",
						className: 'ucec-report-modal-field ucec-report-modal-field--ceus',
						attr: {
							type: "number",
							min: "0.1"
						}
					},
					{
						label: UO_CEU_EDITOR.l10n.report.form.date,
						name: "date",
						type: "datetime",
						format: 'MMMM DD YYYY, h:mm:ss a',
						className: 'ucec-report-modal-field ucec-report-modal-field--date',
						attr: {
							readonly: 'readonly'
						}
					},
					{
						name: "report_mode",
						type: "hidden",
						className: 'ucec-report-datatables-hidden',
						def: UO_CEU_EDITOR.report_mode
					}
				]
			} );
			
			editor.on( 'opened', (e, id, action, data) => {
				
				// Get the container
				const $container = $( editor.dom.wrapper );

				// Get the users dropdown
				const $usersDropdown = $container.find( '#DTE_Field_user_dropdown' );

				// Get the courses dropdown
				const $coursesDropdown = $container.find( '#DTE_Field_course' );

				// Render the users dropdown
				$usersDropdown.select2( {
					theme: 'default ucec-select2',
					minimumInputLength: 3,
					minimumResultsForSearch: 100,
					escapeMarkup: function ( m ){
						return m;
					},
					ajax: {
						type: 'POST',
						url: UO_CEU_EDITOR.api.root + '/get_select2_users',
						dataType: 'json',
						delay: 250,
						beforeSend: function ( xhr ){
							xhr.setRequestHeader( 'X-WP-Nonce', UO_CEU_EDITOR.api.nonce );
						},
						data: function( params ){
							var query = {
								search: params.term
							}

							if (_this.groupLeaderData) {
								query.group_leader_users = _this.groupLeaderData.all_user_ids;
							}

							return query;
						},
						cache: true,
						processResults: function( data ){
							return {
								results: data
							};
						}
					},
					templateResult: function ( option ){
						let output;

						// Parse options if it contains user data
						if (option.text.indexOf( '::' ) != -1) {
							// Get user data
							let userData = option.text.split( '::' ),
								user     = {
									name: userData[0],
									email: userData[1],
								};

							// Create container
							const $container = document.createElement( 'span' );
							// Add class
							$container.classList.add( 'ucec-report-filter-users-dropdown' );

							// Add the user name
							$container.innerText = user.name;

							// Add the user email
							const $userEmail = document.createElement( 'span' );
							// Add class
							$userEmail.classList.add( 'ucec-report-filter-users__subtitle' );
							// Add the data
							$userEmail.innerText = user.email;

							// Append the email
							$container.appendChild( $userEmail );

							// Assign jQuery object to .text property
							output = $container;
						} else {
							output = option.text;
						}

						// Return modified option
						return output;
					},
					templateSelection: function ( option ){
						let output;

						// Parse options if it contains user data
						if (option.text.indexOf( '::' ) != -1) {
							// Get user data
							let userData = option.text.split( '::' ),
								user     = {
									name: userData[0],
									email: userData[1],
								};

							// Create container
							const $container = document.createElement( 'span' );
							// Add class
							$container.classList.add( 'ucec-report-filter-users-selected' );

							// Add the user name
							$container.innerText = user.name;

							output = $container;
						} else {
							output = option.text;
						}

						// Return modified option
						return output;
					},
					escapeMarkup: function ( m ){
						return m;
					}
				} );

				$usersDropdown.on( 'change', () => {
					// Get the value
					const value = $usersDropdown.val();

					// Set the value of the field
					editor.val( 'user', value );
				});

				// Render the courses dropdown
				$coursesDropdown.select2( {
					theme: 'default ucec-select2',
				} );

				if( 'edit' == action ) {
					var selectedRow = _this.$elements.dataTable.row('.selected').data();
					
					if( selectedRow.ceu_course === 'manual-ceu' ) {
						$('#DTE_Field_customCourse').val(selectedRow.ceu_title);
					}	

					if( selectedRow.ceu_date !== '' ) {
						const ceu_date = new Date(selectedRow.ceu_date * 1000);

						if( ceu_date ) {
							$('#DTE_Field_date').val(selectedRow.date + " " + selectedRow.time);
						}
					}

					$('#DTE_Field_ceus').val(selectedRow.ceu_earned);
				}

				if( 'create' == action ) {
					$('#DTE_Field_date').val('');
					$('#DTE_Field_customCourse').val('');
					$('#DTE_Field_ceus').val('');
				}

			} );

			editor.on( 'postSubmit', function ( e, json, data, action, xhr ){
				// WP returns rest cookie invalid
				if (null !== json) {
					if (typeof json.code != "undefined" && 'rest_cookie_invalid_nonce' === json.code) {
						json.error = json.message + '  <button onClick="window.location.reload();">' + UO_CEU_EDITOR.l10n.report.form.refreshPage + '</button>';
					}
				}
				if (typeof json.fieldErrors !== 'undefined' && json.fieldErrors[0].name) {
					$( '.DTE_Form_Info' ).text( json.fieldErrors[0].status );
					console.log( json.fieldErrors );
				}
				if (typeof json.success !== 'undefined' && true === json.success && true === json.reload) {
					window.location.reload();
				}
			} );

			// Delete a record
			this.$elements.table.on( 'click', 'a.editor_remove', function ( e ){
				e.preventDefault();

				editor.remove( $( this ).closest( 'tr' ), {
					title: UO_CEU_EDITOR.l10n.report.remove.title,
					message: UO_CEU_EDITOR.l10n.report.remove.confirm,
					buttons: UO_CEU_EDITOR.l10n.report.remove.submit
				} );
			} );

			// Build the column definitions.
			const exportColumns = [];
			const columnDefs = [];
			const columns = UO_CEU_EDITOR.columns;
			let i = 0;
			for (let column in columns) {
				const name = columns[column].name;
				const def = {
					targets: i,
					className: `ucec-report-body-cell ucec-report-body-cell--${name}`,
					data:null,
					orderable: true,
					visible: true,
				}

				// Check if the column has a render function defined and if it's a string.
				if ( typeof columns[column].render !== 'undefined' && typeof columns[column].render === 'string' ) {
					let rendered = false;
					const renderFunction = columns[column].render;
					// check if a function exists in the window object.
					if ( typeof window[renderFunction] === 'function' ) {
						def.render = window[renderFunction];
						rendered = true;
					} else {
						// Check if it's a function in our object.
						if ( typeof _this[renderFunction] === 'function' ) {
							def.render = _this[renderFunction];
							rendered = true;
						}
					}
					if ( !rendered ) {
						console.error( `CourseReport : render function ${renderFunction} not found.` );
					}
				}

				// Check if the column has a data property defined.
				if ( typeof columns[column].data !== 'undefined' && typeof columns[column].data === 'string' ) {
					// Check if it's a callback function.
					if ( typeof window[columns[column].data] === 'function' ) {
						def.data = window[columns[column].data];
					} else {
						def.data = columns[column].data;
					}
				}

				if ( 'checkbox' === name ) {
					def.data = function (row, type, val, meta) {
						return meta.row;
					};
				}

				// Check if the column is orderable
				if ( typeof columns[column].orderable !== 'undefined' ) {
					// Check if it's a bool value.
					if ( typeof columns[column].orderable === 'boolean' ) {
						def.orderable = columns[column].orderable;
					}
				}

				// Check for a custom className
				if ( typeof columns[column].className !== 'undefined' ) {
					def.className = columns[column].className;
				}

				// Check if the column is visible
				if ( typeof columns[column].visible !== 'undefined' ) {
					// Check if it's a bool value.
					if ( typeof columns[column].visible === 'boolean' ) {
						def.visible = columns[column].visible;
					}
				}

				// Check if column is exportable
				if ( typeof columns[column].export !== 'undefined' ) {
					// Check if it's a bool value and true.
					if ( typeof columns[column].export === 'boolean' && columns[column].export ) {
						exportColumns.push( i );
					}
				}

				columnDefs.push( def );
				i++;
			}

			// Add the export column
			const buttonCommon = {
				exportOptions: {
					columns: exportColumns,
					rows: null,
					selected: false,
					format: {
						body: function (data, row, column, node) {
							if(!data.length){
								return data;
							}
							// Create a jQuery object from the data
							var $data = $('<div>').html(data);
							// Remove hidden spans
							$data.find('span.ucec-report-datatables-hidden').remove();
							// Get the text content and replace multiple spaces, tabs, and new lines with a single space
							data = $data.text().replace(/\s+/g, ' ').trim();
							// Return the data
							return data;
						}
					}
				}
			};

			const buttonsConig = [
				$.extend(true, {}, buttonCommon, {
					extend: 'csv',
					filename: _this.getExportFileName,
				}),
				$.extend(true, {}, buttonCommon, {
					extend: 'excelHtml5',
					filename: _this.getExportFileName,
				}),
			];

			// Dynamically add action buttons.
			const actionButtons = UO_CEU_EDITOR.buttons || {};
			if ( actionButtons.hasOwnProperty( 'add' ) && actionButtons.add === 'on' ) {
				buttonsConig.push( {extend: "create", editor: editor} );
			}

			if ( actionButtons.hasOwnProperty( 'edit' ) && actionButtons.edit === 'on' ) {
				buttonsConig.push( {extend: "edit", editor: editor} );
			}

			if ( actionButtons.hasOwnProperty( 'delete' ) && actionButtons.delete === 'on' ) {
				buttonsConig.push( {extend: "remove", editor: editor} );
			}

			// Generate the table data.
			const tableData = {
				deferRender: true,
				scrollX: true,  // Enable horizontal scrolling
				autoWidth: false,  // Prevent auto-resizing columns
				responsive: false,  // Disable responsive behavior
				fixedHeader: false,  // Disable fixed header
				data: UO_CEU_EDITOR.data,
				columnDefs: columnDefs,
				dom: 'Blrtip',
				order: [[3, 'asc']],
				select: {
					style: 'multi',
					selector: '.ucec-report-checkbox',
					toggleable: true
				},
				buttons:buttonsConig,
				createdRow: function ( row, data, dataIndex ){
					$( row ).addClass( 'ucec-report-results-table__tr' );
				},
				paging: true,
				pageLength: parseInt(UO_CEU_EDITOR.page_length),
				lengthMenu: [ [10, 25, 50, 100, 200], [10, 25, 50, 100, 200] ],
				initComplete: function (){
					// Add ready class
					_this.$elements.container.addClass( 'ucec-report--datatables-ready' );

					// Bind export buttons
					_this.bindExportButtons();

					_this.editorFormEvents();
				},
			};

			// Create instance of DataTables
			this.$elements.dataTable = this.$elements.table.DataTable( tableData );
			// Ensure column and body alignment.
			this.forceAlignHeaderWithBody();
			$(window).on('resize', _this.forceAlignHeaderWithBody);
		},

		forceAlignHeaderWithBody: function (){
			const $container = $( '.ucec-report' );
			setTimeout(function () {
				let $bodyTable = $('.dataTables_scrollBody table', $container);
				let bodyWidth = $bodyTable.outerWidth();		
				// Sync the header width to match the body
				$('.dataTables_scrollHeadInner', $container).width(bodyWidth);
			}, 50);
		},

		editorFormEvents: function (){
			$( 'body' )
				.on( 'change', '#DTE_Field_course', function ( e ){
					var selectedCourse = $( this ).children( "option:selected" ).val();
					if ('0' === selectedCourse) {
						$( '.DTE_Field_Name_ceus' ).show();
						$( '.DTE_Field_Name_customCourse' ).show();
						$( '.DTE_Field_Name_completeCourse' ).hide();
						$( "#DTE_Field_completeCourse_0" ).prop( "checked", true );
						$( '.DTE_Field_Name_date' ).show();
					} else {
						$( '.DTE_Field_Name_ceus' ).hide();
						$( '.DTE_Field_Name_customCourse' ).hide();
						$( '.DTE_Field_Name_completeCourse' ).show();
						$( "#DTE_Field_completeCourse_1" ).prop( "checked", true );

					}
				} )
				.on( 'change', '.DTE_Field_Name_completeCourse input[type=radio][name=completeCourse]', function ( e ){
					if ('0' === this.value) {
						$( '.DTE_Field_Name_date' ).show();
					} else {
						$( '.DTE_Field_Name_date' ).hide();
					}
				} )
				.on( 'click', '.ucec-report-checkbox', function ( e ){
					var tbl = $( '#ucec-course-report' ).DataTable();
					var selectedRows = tbl.rows('.selected').data().length;
					if( selectedRows > 1 ) {
						$('.buttons-edit', $('.ucec-report-results')).attr('disabled', 'disabled');
					} else {
						$('.buttons-edit', $('.ucec-report-results')).removeAttr('disabled');
					}
				} );
		},

		bindExportButtons: function (){
			const exports = [
				{ 
					key : 'csv',
					original: null,
					cloned: null, 
				},
				{ 
					key : 'excel',
					original: null,
					cloned: null, 
				},
			];
		
			// Loop through buttons
			exports.forEach( ( button ) => {
				// Get original button
				button.original = $( `.ucec .buttons-${button.key}` );
		
				// Get cloned button
				//let key = 'excel' === button.key ? 'excelHtml5' : button.key;
				button.cloned =  $( `.ucec #ucec-report-export-${button.key}` );
		
				// Click original button when the cloned one is clicked
				button.cloned.on( 'click', function (){
					button.original.trigger( 'click' );
				} );
			} );
		},

		getExportFileName: function (){
			// Get today's date
			let today = new Date();
			// Create file name.
			return CourseReport.strings.csvFileName.replace( '%s', today.toLocaleDateString() );
		},

		renderCheckbox: function ( data, type, row, meta ){
			return '<div class="ucec-report-checkbox"></div>';
		},

		renderUser: function ( data, type, full, meta ){
			// Sorting
			if ( type !== 'display' && type !== 'filter' ) {
				return data.first_name + data.last_name;
			}

			// Display
			let return_data = `
				<div data-row-id="${meta.row}" id="dt-user-id" data-user-id="${data.user_id}" class="ucec-report-cell-user">
			`;
			
			// Add avatar
			if (data.avatar !== "") {
				let imgAlt = UO_CEU_EDITOR.l10n.report.table.usersAvatar;
				imgAlt = imgAlt.replace('%s', data.first_name);
				return_data += `
					<div class="ucec-report-cell-user__avatar">
						<img src="${data.avatar}" alt="${imgAlt}" class="ucec-report-cell-user__avatar-img" loading="lazy">
					</div>
				`;
			}
			
			return_data += `
				<div class="ucec-report-cell-user__info">
					<div class="ucec-report-cell-user__name">
						<a href="${data.user_profile}" target="_blank" class="ucec-report-external-link">${data.first_name} ${data.last_name}</a>
					</div>
					<div class="ucec-report-cell-user__email">${data.email}</div>
				</div>
			</div>
			`;
			
			return return_data;
		},

		renderCourse: function ( data, type, row ){
			let courseTitle = data.ceu_title;

			// Sorting
			if ( type !== 'display' && type !== 'filter' ) {
				return courseTitle;
			}

			// Display
			if (null !== data.course_link && "" !== data.course_link ) {
				courseTitle = `<a href="${data.course_link}" target="_blank" class="ucec-report-external-link">${data.ceu_title}</a>`;
			}

			return `<div id="dt-course-id" data-course-id="${data.course_id}" class="ucec-report-cell-course">${courseTitle}</div>`;
		},

		renderDate: function ( data, type, row ){
			// Sorting
			if ( type !== 'display' && type !== 'filter' ) {
				return data.ceu_date;
			}

			// Display
			return `
				<span id="dt-ceu-date" data-date="${data.ceu_date}" class="ucec-report-datatables-hidden">${data.ceu_date}</span>
				<div class="ucec-report-cell-date-and-time">
					<div class="ucec-report-cell-date-and-time__date">${data.date}</div>
					<div class="ucec-report-cell-date-and-time__time">${data.time}</div>
				</div>
			`;
		},

		renderCeusEarned: function ( data, type, row ){
			return parseInt(data.ceu_earned * 100) / 100;
		},

		renderTotal: function ( data, type, row ){
			return parseInt(data * 100) / 100;
		}
	}

} )( jQuery );